'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  margin-bottom: 24px;\n  padding: ', ';\n  background: ', ';\n  box-shadow: ', ';\n  border-radius: ', 'px;\n  ', ';\n  ', ';\n  margin-bottom: ', ';\n'], ['\n  position: relative;\n  margin-bottom: 24px;\n  padding: ', ';\n  background: ', ';\n  box-shadow: ', ';\n  border-radius: ', 'px;\n  ', ';\n  ', ';\n  margin-bottom: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = require('../../utils');

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Panel = _styledComponents2.default.div(_templateObject, function (props) {
  return props.padding;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.boxShadowLight ? props.theme.boxShadow[3] : props.theme.boxShadow[props.boxShadow];
}, function (props) {
  return props.borderRadius;
}, (0, _helpers.boolStyle)('noMargin', 'margin-bottom: 0;'), (0, _helpers.boolStyle)('dark', 'background: #56575b;'), function (props) {
  return props.marginBottom;
});
Panel.displayName = 'Panel';
Panel.defaultProps = {
  padding: '24px',
  boxShadow: '1',
  borderRadius: 2
};

var NitroPanel = function NitroPanel(_ref) {
  var className = _ref.className,
      padding = _ref.padding,
      children = _ref.children,
      noMargin = _ref.noMargin,
      disabled = _ref.disabled,
      borderRadius = _ref.borderRadius,
      boxShadowLight = _ref.boxShadowLight,
      marginBottom = _ref.marginBottom,
      dark = _ref.dark;

  return _react2.default.createElement(
    Panel,
    {
      className: className,
      padding: padding,
      noMargin: noMargin,
      borderRadius: borderRadius,
      dark: dark,
      boxShadowLight: boxShadowLight,
      marginBottom: marginBottom
    },
    children,
    disabled && _react2.default.createElement(_utils.DisableCover, null)
  );
};
NitroPanel.propTypes = {
  padding: _propTypes2.default.string,
  children: _propTypes2.default.node,
  noMargin: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  borderRadius: _propTypes2.default.number,
  dark: _propTypes2.default.bool,
  marginBottom: _propTypes2.default.string,
  boxShadowLight: _propTypes2.default.bool
};

exports.default = NitroPanel;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-panel/NitroPanel.js
// module id = 3024
// module chunks = 4